/* eslint-disable unicorn/filename-case -- TODO rename later */
export enum ResourceType {
  Artifact = "artifact",
  Comment = "comment",
  Function = "function",
  Job = "job",
  Model = "model",
  // Every v3 resource -- models and artifacts included, but the only way to reach a plain file,
  // a connected file or a container -- carries its access tuples on this object type, keyed by
  // resource id. Not to be confused with `File`, a different object keyed by file id.
  Resource = "resource",
  System = "system",
  User = "user",
}
